
































import { Watch, Component, Prop, Vue } from 'vue-property-decorator';

// components
import TaskAdd from './TaskAdd.vue'
import TaskList from './TaskList.vue'
import Analytics from './Analytics.vue'
import Ringtone from './Ringtone.vue'

@Component({
  components: {
    TaskAdd,
    TaskList,
    Analytics,
    Ringtone
  }
})
export default class NavBlock extends Vue {
  @Prop() private navList!: string[];

  initActive: string | null = null

  activeHandler(str: string) {
    return (str === this.initActive)? 'nav-group__item--active' : ''
  }

  selectHandler(str: string) {
    if(this.initActive === str) return this.initActive = null
    this.initActive = str
  }

  afterEnterHandler(el: any) {
    el.style.transitionDelay = null
  }

  showHandler(section: string) {
    return (section === this.initActive)
  }

  navGroupItemStyle(id: number) {
    return `transition-delay: ${id * 0.15}s;`
  }

  ctrlClickHandler() {
    if(this.initActive) return this.initActive = null
    this.initActive = this.navList[0]
  }

  get isNavActive() {
    return (this.initActive === null)? false : true
  }

  get arrowClass() {
    return (this.initActive === null)? 
      'nav-ctrl__arrow--left' : 
      'nav-ctrl__arrow--right';
  }
}
